import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function getPublicConfig() {
  const { data } = await api.get("/config");
  return data;
}

export async function joinWaitlist({ handle, email, turnstileToken }) {
  const { data } = await api.post("/waitlist", {
    handle,
    email,
    turnstile_token: turnstileToken,
  });
  return data;
}

export async function getWaitlistCount() {
  const { data } = await api.get("/waitlist/count");
  return data;
}

export async function trackPageview(path = "/", referrer = "") {
  try {
    await api.post("/pageview", { path, referrer });
  } catch {
    /* never block the page on analytics */
  }
}

export async function checkHandle(handle) {
  const { data } = await api.get(`/waitlist/check/${encodeURIComponent(handle)}`);
  return data;
}

export async function getHandleSuggestions(handle, limit = 3) {
  const { data } = await api.get(
    `/waitlist/suggestions/${encodeURIComponent(handle)}`,
    { params: { limit } }
  );
  return data;
}

// ---------- Admin ----------
export async function adminLogin(passcode) {
  const { data } = await api.post("/admin/login", { passcode });
  return data;
}

export async function adminListWaitlist(passcode, { limit = 500, skip = 0 } = {}) {
  const { data } = await api.get("/admin/waitlist", {
    headers: { "X-Admin-Passcode": passcode },
    params: { limit, skip },
  });
  return data;
}

export function adminCsvUrl() {
  return `${API}/admin/waitlist.csv`;
}

export async function adminDeleteEntry(id, passcode) {
  const { data } = await api.delete(`/admin/waitlist/${encodeURIComponent(id)}`, {
    headers: { "X-Admin-Passcode": passcode },
  });
  return data;
}

export async function adminCreateEntry({ handle, email, reason }, passcode) {
  const { data } = await api.post(
    "/admin/waitlist",
    { handle, email, reason },
    { headers: { "X-Admin-Passcode": passcode } }
  );
  return data;
}

export async function adminRenumber(passcode) {
  const { data } = await api.post(
    "/admin/waitlist/renumber",
    {},
    { headers: { "X-Admin-Passcode": passcode } }
  );
  return data;
}

export async function adminSendInvite(id, passcode) {
  const { data } = await api.post(
    `/admin/waitlist/${encodeURIComponent(id)}/invite`,
    {},
    { headers: { "X-Admin-Passcode": passcode } }
  );
  return data;
}

export async function adminUpdateEntry(id, updates, passcode) {
  const { data } = await api.patch(
    `/admin/waitlist/${encodeURIComponent(id)}`,
    updates,
    { headers: { "X-Admin-Passcode": passcode } }
  );
  return data;
}

export async function adminImportCsv(csvText, passcode) {
  const { data } = await api.post(
    "/admin/waitlist/import",
    { csv: csvText },
    { headers: { "X-Admin-Passcode": passcode } }
  );
  return data;
}

export async function adminAnalytics(passcode) {
  const { data } = await api.get("/admin/analytics", {
    headers: { "X-Admin-Passcode": passcode },
  });
  return data;
}
